import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api/client";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);

const EMPTY = { items: [], subtotal: 0, tax: 0, delivery_fee: 0, total: 0 };

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [cart, setCart] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setCart(EMPTY);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const addToCart = async (product_id, quantity) => {
    const { data } = await api.post("/cart/add", { product_id, quantity });
    setCart(data);
    return data;
  };

  const removeFromCart = async (product_id) => {
    const { data } = await api.delete(`/cart/remove/${product_id}`);
    setCart(data);
  };

  const clearCart = async () => {
    await api.post("/cart/clear");
    setCart(EMPTY);
  };

  const count = cart.items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ cart, loading, addToCart, removeFromCart, clearCart, refresh, count }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
